import { render, staticRenderFns } from "./PdiManager.vue?vue&type=template&id=4babebd0&scoped=true"
import script from "./PdiManager.vue?vue&type=script&lang=js"
export * from "./PdiManager.vue?vue&type=script&lang=js"
import style0 from "./PdiManager.vue?vue&type=style&index=0&id=4babebd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babebd0",
  null
  
)

export default component.exports